import { ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form, Row, Tabs
} from "antd";
import { useState } from "react";
import { useParams } from 'react-router-dom';
import BackButton from "../../../commons/BackButton";
import { ROOT_URL } from "../../../constants/api";
import { nofication } from './../../../commons/Nofication';
import Upload from './../../../commons/Upload';
import AboutForm from './../../../components/form/aboutForm';
import MainLayout from "./../../../components/mainLayout";
import { authApis } from "./../../../services/authApi";
import "./index.scss";
import UploadMultiple from './../../../commons/UploadMultiple/UploadMultiple';

const { TabPane } = Tabs;
const onChange = (key) => {
    console.log(key);
};
const Register = () => {
    const [fileList, setFileList] = useState([]);
    const [imageUrl, setImageUrl] = useState([]);
    const [idsRemove, setIdsRemove] = useState([]);
    const [imgCurrent, setImgCurrent] = useState([]);
    const [content, setContent] = useState({
        content_vi: "",
        content_en: "",
        content_kr: "",
    });
    const [form] = Form.useForm();
    let { id } = useParams();

    const onChangeContentValue = (lang) => {
    }
    useState(() => {
        if (id) {
            authApis
            .getStaticPage(2)
            .then((data) => {
                if (data.status_code === 200) {
                    form.setFieldsValue(data.banner)
                    form.setFieldsValue({ fields: data.statices })
                    setContent({
                        content_vi: data.banner?.content_vi ?? '<p></p>',
                        content_en: data.banner?.content_en ?? '<p></p>',
                        content_kr: data.banner?.content_kr ?? '<p></p>',
                    });
                    setImageUrl(data.images)
                    setImgCurrent(data.images)
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
            });
        }
    })

    const onFinish = async () => {
        const values = form.getFieldValue();
        console.log(values)
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            if (key === 'content_vi' || key === 'content_en' || key === 'content_kr') {
                formData.append(key, values[key]?.editor ? values[key]?.editor.getData() : values[key]);
            } else {
                formData.append(key, values[key]);
            }
            if (key === 'fields'){
                formData.append(key, JSON.stringify(values[key]));
            }
        }
        id && formData.append('id', 2);
        if (fileList && fileList.length !== 0) {
            for (let i = 0; i < fileList.length; i++) {
                formData.append('logo' + i, fileList[i])
                console.log('fileList[i]', fileList[i])
            }
        }
        formData.append('total', fileList && fileList.length)
        formData.append('idsRemove', idsRemove)
        formData.append('type', 2)
        await authApis
            .addStaticPage(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="About"
            link="/about/"
            titleNew="About / Detail"
        >
            <Form form={form} layout="vertical" onFinish={onFinish} colon={true}>
                <Row gutter={16}>
                    <Col span={24} style={{ paddingRight: "19px" }}>
                        <div className="box-class">
                            <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="" key="1">
                                    <AboutForm lang={'vi'} onChangeContentValue={onChangeContentValue} content={content} id={id} isBanner={false}/>
                                </TabPane>
                                {/* <TabPane tab="Tiếng anh" key="2">
                                    <AboutForm lang={'en'} onChangeContentValue={onChangeContentValue} content={content} id={id} isBanner={false}/>
                                </TabPane>
                                <TabPane tab="Tiếng hàn" key="3">
                                    <AboutForm lang={'kr'} onChangeContentValue={onChangeContentValue} content={content} id={id} isBanner={false}/>
                                </TabPane> */}
                            </Tabs>
                            {/* <Form.Item label="Banner" colon={true}>
                                <Upload imageUrl={imageUrl} setFileList={setFileList} setImageUrl={setImageUrl} span={24} />
                            </Form.Item> */}
                            {/* <Form.Item label="Banner" colon={true}>
                                <UploadMultiple imageUrl={imageUrl} setFileList={setFileList} setImageUrl={setImageUrl} setIdsRemove={setIdsRemove} idsRemove={idsRemove} imgCurrent={imgCurrent} fileList={fileList} span={24} />
                            </Form.Item> */}
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton/>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
